import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'

export interface ValueCardProps {
  title: string
  description: any
  icon: IconName
  iconPrefix: IconPrefix
}

export const useValueCard = (props: ValueCardProps) => {
  return {
    ...props,
  }
}
